import React from "react";
import "./skills.css";
import { HiLightningBolt } from "react-icons/hi";

const Skills = () => {
  return (
    <section className="" id="skills">
      <h5>The</h5>
      <h2>Skills</h2>

      <div className="container skills__container">
        <div className="skills__webdev">
          <h3> Web Development</h3>
          <div className="skills__content">
            <article className="skills__details">
              <HiLightningBolt className="skills__details__icon" />
              <div>
                <h4>HTML</h4>
                <small>Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <HiLightningBolt className="skills__details__icon" />
              <div>
                <h4>REACT JS</h4>
                <small  >Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <HiLightningBolt className="skills__details__icon" />
              <div>
                <h4>JAVA SCRIPT</h4>
                <small  >Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <HiLightningBolt className="skills__details__icon" />
              <div>
                <h4>BOOTSTRAP 4</h4>
                <small >Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <HiLightningBolt className="skills__details__icon" />
              <div>
              <h4>CSS</h4>
                <small  >Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <HiLightningBolt className="skills__details__icon" />
              <div>
              <h4>TYPESCRIPT</h4>
                <small  >Experienced</small>
              </div>
            </article>
          </div>
        </div>
        <div className="skills__datascience">
          <h3>UI/UX DESIGN</h3>
          <div className="skills__content">
            <article className="skills__details">
              <HiLightningBolt className="skills__details__icon" />
              <div>
                <h4>Figma</h4>
                <small  >Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <HiLightningBolt className="skills__details__icon" />
              <div>
                <h4>Adobe XD</h4>
                <small  >Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <HiLightningBolt className="skills__details__icon" />
              <div>
                <h4>Adobe Photoshop</h4>
                <small  >Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <HiLightningBolt className="skills__details__icon" />
              <div>
                <h4>Adobe Illustrator</h4>
                <small  >Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <HiLightningBolt className="skills__details__icon" />
              <div>
                <h4>Adobe Premiere Pro</h4>
                <small  >Experienced</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
